var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabBasic',{key:_vm.$route.name,attrs:{"actual-breadcrumb":_vm.breadcrumb,"items":_vm.items,"replace-route":"","show-breadcrumbs":""}})}
var staticRenderFns = []

export { render, staticRenderFns }